// extracted by mini-css-extract-plugin
export default {"smartphone":"Smartphone_smartphone__2m9y-"};